import * as React from "react";
import { observer } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  PaperProps,
} from "@mui/material";
import Draggable1 from "react-draggable";
import { useRootStore } from "../../../store/contexts";
const Draggable: any = Draggable1;

type GridExpressProps = {
  title: string;
  description: string;
  open: boolean;
  onClose: () => void;
};

export const ErrorDialog: React.FC<GridExpressProps> = observer(
  ({ title, description, open, onClose }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;
    const PaperComponent = (props: PaperProps) => {
      const nodeRef = React.useRef(null);
      return (
        <Draggable
          nodeRef={nodeRef}
          handle="#draggable-dialog-title"
          cancel={'[class*="MuiDialogContent-root"]'}
        >
          <Paper ref={nodeRef} {...props} />
        </Draggable>
      );
    };

    return (
      <Dialog
        open={open}
        onClose={() => onClose()}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        sx={{ zIndex: 10400 }}
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ whiteSpace: "pre-line" }}>
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => onClose()}>
            {langStore.cancelCommand}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);
